<template>
  <div :class="headerclass ? 'header' : 'header top'" ref="element">
    <div class="content">
      <div class="logo" @click="logo">
        <router-link to="/pc/Index"
          ><img src="../../assets/pc/logo.svg" alt=""
        /></router-link>
      </div>
      <div class="nav">
        <div class="nav-all">
          <el-menu
            class="el-menu-vertical-demo"
            mode="horizontal"
            :default-active="activeIndex"
            :popper-append-to-body="false"
            text-color="#151b26"
            @select="jumpPage"
          >
            <el-submenu
              index="Learn"
              :class="{ 'El-Submenu': ElSubmenuborder === 'Learning' }"
            >
              <template slot="title" class="template">
                {{ type === "zh" ? "学习" : "Learning" }}
              </template>

              <el-menu-item-group
                class="menu-item-group"
                style="margin-left: 280px"
              >
                <!-- <span slot="title" class="lfet">DISCOVER DO Network</span> -->
                <div style="margin-top: 0px"></div>
                <router-link to="/pc/About">
                  <el-menu-item
                    index="1-1"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-1' }"
                  >
                    About DO Network
                  </el-menu-item>
                </router-link>
                <!-- <a
                  href="https://docs.google.com/document/d/1LOIN3HcdEetDM_fT_OcHRVFyqFY7_h1cBJIZEiOFVN8/edit?usp=sharing
"
                  target="_blank"
                > -->
                <router-link to="/pc/Token">
                  <el-menu-item
                    index="1-2"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-2' }"
                  >
                    DO Token&Economy
                  </el-menu-item>
                </router-link>
                <a target="_blank" href="https://fastcdn.donetwork.io/media/DONetwork+whitepaper.pdf">
                  <el-menu-item
                    index="1-3"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '2-2' }"
                  >
                   White Paper
                  </el-menu-item>
                </a>
                <!-- </a> -->
                <router-link to="/pc/User">
                  <el-menu-item
                    index="1-4"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-3' }"
                  >
                    User Guide
                  </el-menu-item>
                </router-link>
                <a href="https://www.donetwork.io/doc/" target="_blank">
                <el-menu-item
                  index="1-5"
                  class="DOnetwork-introductory"
                  :class="{ active1: Index === '1-4' }"
                  
                >
                  DO Wiki
                </el-menu-item>
              </a>
                <!-- <a
                  href="https://docs.google.com/spreadsheets/d/19uK1oakro0ZGnJnOowRqLHG-jLAderInuZDKvwzn21k/edit?usp=sharing"
                  target="_blank"
                >
                  <el-menu-item
                    index="1-5"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-5' }"
                  >
                    Ecology Profolio
                  </el-menu-item>
                </a> -->
                <router-link to="/pc/TechRoadmap">
                  <el-menu-item
                    index="1-6"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-5' }"
                  >
                    Roadmap
                  </el-menu-item>
                </router-link>
                <router-link to="/pc/Brand">
                  <el-menu-item
                    index="1-7"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '1-6' }"
                  >
                    Brand Kits
                  </el-menu-item>
                </router-link>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu
              index="Develop"
              class="clearfix"
              :class="{ 'El-Submenu': ElSubmenuborder === 'Develop' }"
            >
              <template slot="title">
                {{ type === "zh" ? "开发者" : "Developer" }}
              </template>

              <el-menu-item-group
                class="menu-item-group"
                style="margin-left: 400px"
              >
                <a
                  href="https://www.donetwork.io/doc/developer"
                  target="_blank"
                >
                  <el-menu-item
                    index="3-1"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '3-1' }"
                  >
                    <!-- <router-link :to="'/' + goPage + '/Login'"> -->
                    <p>Developer Documentation</p>

                    <!-- </router-link> -->
                  </el-menu-item>
                </a>
                <a href="https://www.donetwork.io/doc/" target="_blank">
                  <el-menu-item
                    index="3-2"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '3-2' }"
                  >
                    <p>Deploy Documentation</p>
                  </el-menu-item>
                </a>
                <a href="https://www.donetwork.io/doc/json-rpc" target="_blank">
                  <el-menu-item
                    index="3-3"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '3-3' }"
                  >
                    <p>API Documentation</p>
                  </el-menu-item>
                </a>

                <router-link to="/pc/GrantApplication">
                  <el-menu-item
                    index="3-4"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '3-4' }"
                  >
                    <p>Submit Your Application</p>
                  </el-menu-item>
                </router-link>
                <a href="https://www.donetwork.io/doc/" target="_blank">
                  <el-menu-item
                    index="3-5"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '3-5' }"
                  >
                    <p>RUN A NODE</p>
                  </el-menu-item>
                </a>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu
              index="Community"
              class="clearfix"
              :class="{ 'El-Submenu': ElSubmenuborder === 'Community' }"
            >
              <template slot="title"
                >{{ type === "zh" ? "社区" : "Community" }}
              </template>

              <el-menu-item-group
                class="menu-item-group"
                style="margin-left: 560px"
              >
                <el-menu-item
                  index="4-1"
                  class="DOnetwork-introductory"
                  :class="{ active1: Index === '4-1' }"
                >
                  <p @click="promptDilaogBox">Governance</p>
                </el-menu-item>
                <el-menu-item
                  index="4-1"
                  class="DOnetwork-introductory"
                  :class="{ active1: Index === '4-2' }"
                >
                  <p @click="promptDilaogBox">Social</p>
                </el-menu-item>
                <div class="Socialimg">
                  <a href="https://x.com/Donetwork_club" target="_blank">
                    <img src="../../assets/pc/1.png" />
                  </a>
                  <a target="_blank" href="https://t.me/DoNetworkclub">
                    <img src="../../assets/pc/telegram.svg" />
                  </a>
                  <a
                    target="_blank"
                    href="https://discord.gg/donetwork"
                    class="icon"
                    ><img src="../../assets/pc/intro/discord.svg" alt=""
                  /></a>
                  <a href="https://github.com/DONetworkChain " target="_blank">
                    <img src="../../assets/pc/2.png" />
                  </a>
                  <a href="https://donetwork.medium.com/ " target="_blank">
                    <img src="../../assets/pc/3.png" />
                  </a>
                  <a
                    href="https://app.galxe.com/quest/DONetwork"
                    target="_blank"
                  >
                    <img src="../../assets/pc/4.png" />
                  </a>
                  <a
                    href="https://zealy.io/cw/donetwork/questboard"
                    target="_blank"
                  >
                    <img src="../../assets/pc/5.png" />
                  </a>
                </div>
                <!-- <a href="https://x.com/Donetwork_club " target="_blank">
                  <el-menu-item
                    index="4-2"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-2' }"
                  >
                    <p>Twitter</p>
                  </el-menu-item>
                </a>
                <a href="https://discord.gg/donetwork " target="_blank">
                  <el-menu-item
                    index="4-3"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-3' }"
                  >
                    <p>Discord</p>
                  </el-menu-item>
                </a>
                <a href="https://t.me/DoNetworkclub " target="_blank">
                  <el-menu-item
                    index="4-4"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-4' }"
                  >
                    <p>Telegram</p>
                  </el-menu-item>
                </a>
                <a href="https://github.com/DONetworkChain " target="_blank">
                  <el-menu-item
                    index="4-5"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-5' }"
                  >
                    <p>Github</p>
                  </el-menu-item>
                </a>
                <a href="https://donetwork.medium.com/ " target="_blank">
                  <el-menu-item
                    index="4-6"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-6' }"
                  >
                    <p>Medium</p>
                  </el-menu-item>
                </a>
                <a href="https://galxe.com/DONetwork" target="_blank">
                  <el-menu-item
                    index="4-7"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-7' }"
                  >
                    <p>Galxe</p>
                  </el-menu-item>
                </a>
                <a href="https://zealy.io/cw/donetwork/questboard " target="_blank">
                  <el-menu-item
                    index="4-8"
                    class="DOnetwork-introductory"
                    :class="{ active1: Index === '4-8' }"
                  >
                    <p>Zealy</p>
                  </el-menu-item>
                </a> -->
              </el-menu-item-group>
            </el-submenu>
            <el-submenu
              index="Explore DO network"
              class="clearfix"
              :class="{
                'El-Submenu': ElSubmenuborder === 'Explore DO network',
              }"
            >
              <template slot="title">
                {{ type === "zh" ? "技术" : "Explore DO network" }}
              </template>
              <el-menu-item-group class="menu-item-group">
                <a href="https://explorer.donetwork.io/Index" target="_blank">
                  <img
                    src="../../assets/pc/do.png"
                    style="
                      width: 134px;
                      height: 76px;

                      margin-left: 600px;
                    "
                  />
                </a>
              </el-menu-item-group>
              <el-menu-item-group class="menu-item-group">
                <!-- <div style="margin-top: 48px"></div> -->
                <a
                  href="https://apps.apple.com/hk/app/sunnywallet/id6633413398"
                  target="_blank"
                >
                  <el-menu-item
                    index="1-7"
                    class="DOnetwork-introductory xiazai"
                  >
                    <p @mouseover="mouseover()" @mouseout="mouseout()">
                      <img :src="img" />iOS Wallet
                    </p>
                  </el-menu-item>
                </a>
                <div ref="androidWalletWrap" class="android-wallet-wrap">
                  <div
                    class="DOnetwork-introductory xiazai android-wallet-trigger"
                    @click.stop.prevent="toggleAndroidWallet"
                    @mouseenter="showAndroidWallet = true"
                  >
                    <p @mouseover="mouseovera()" @mouseout="mouseouta()">
                      <img :src="imga" />Android Wallet
                    </p>
                  </div>
                  <div v-if="showAndroidWallet" class="android-wallet-popover">
                    <div class="android-wallet-card">
                      <img
                        class="android-wallet-qr"
                        :src="androidDownloadQrcode"
                        alt="Android download qr"
                      />
                      <div class="android-wallet-actions">
                        <a
                          class="android-wallet-btn"
                          href="https://fastcdn.donetwork.io/apk/Sunny-Wallet.apk"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Android Download
                        </a>
                        <div class="android-wallet-tip">Scan the QR code or download directly</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="cions" v-if="isLogin">
        <a href="https://x.com/Donetwork_club" target="_blank">
          <img src="../../assets/pc/1.png" />
        </a>
        <a target="_blank" href="https://t.me/DoNetworkclub">
          <img src="../../assets/pc/telegram.svg" />
        </a>

        <a target="_blank" href="https://discord.gg/donetwork" class="icon"
          ><img src="../../assets/pc/intro/discord.svg" alt=""
        /></a>
        <img :src="iconSrc" class="img1" @click="toggleCions" />

        <div class="cions1" v-if="showCions" @mouseleave="hideCions">
          <a href="https://github.com/DONetworkChain " target="_blank">
            <img src="../../assets/pc/2.png" />
          </a>
          <a href="https://donetwork.medium.com/ " target="_blank">
            <img src="../../assets/pc/3.png" />
          </a>
          <a href="https://app.galxe.com/quest/DONetwork" target="_blank">
            <img src="../../assets/pc/4.png" />
          </a>
          <a href="https://zealy.io/cw/donetwork/questboard" target="_blank">
            <img src="../../assets/pc/5.png" />
          </a>
        </div>
      </div>
    </div>
    <div
      :style="{ height: divH }"
      class="all"
      v-show="flog"
      @touchmove.prevent
      @mousewheel.prevent
    >
      <div class="active">
        <div class="promptDilaogBox">
          <p>in building</p>
          <p @click="promptDilaogBoxBtn" class="promptDilaogBoxBtn">ok</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import {
//   WebLogout,
//   CheckUsersStatus,
//   GetUsersAddress,
// } from "@/assets/server/api.js";
// import Login from "./Login.vue";
// import CheckUser from "./CheckUser.vue";
// import ShowMoney from "./ShowMoney.vue";
import { goPAGE } from "@/utils/utils";
export default {
  // components: {
  //   Login,
  //   CheckUser,
  //   ShowMoney,
  // },
  watch: {
    $route: {
      // 监听路由，页面跳页处理路由并且让当前页面的路由对应到 default-active 从而显示当前菜单选中状态
      handler: function (val) {
        // this.getShowMenu(val.path);
        // this.getPath(val.path);
        // console.log(val);
        if (val.path == "/pc/About") {
          this.Index = "1-1";
        } else if (val.path == "/pc/Token") {
          this.Index = "1-2";
        } else if (val.path == "/pc/User") {
          this.Index = "1-3";
        } else if (val.path == "/pc/TechRoadmap") {
          this.Index = "1-5";
        } else if (val.path == "/pc/Brand") {
          this.Index = "1-6";
        } else if (val.path == "/pc/GrantApplication") {
          this.Index = "3-4";
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  data() {
    return {
      language: "EN",
      language2: "ZH",
      moneyAddress: "",
      headerclass: true,
      type: "",
      dialogVisible: false,
      width: "",
      height: "",
      isGoback: true,
      pathList: [
        {
          type: "proposal",
          path: "/pc/community/Proposal",
          isGoback: false,
        },
        {
          type: "proposal",
          path: "/pc/community/Vote",
          isGoback: false,
        },
        {
          type: "proposal",
          path: "/pc/community/Proposal/Add",
          isGoback: true,
        },
        {
          type: "proposal",
          path: "/pc/community/Proposal/Details",
          isGoback: true,
        },
        {
          type: "task",
          path: "/pc/Task/Details",
          isGoback: true,
        },
        {
          type: "CoreMembersDetails",
          path: "/pc/CoreMembersDetails",
          isGoback: true,
        },
      ],
      isLogin: true,
      userName: "",
      dialogType: "",
      usersStatus: "",
      activeIndex: "index",
      flog: false,
      timeout: "",
      divH: 0,
      Index: "",
      ElSubmenuborder: "",
      img: require("../../assets/pc/apple.png"),
      img2: require("../../assets/pc/apple.png"),
      img1: require("../../assets/pc/applea.png"),
      imga: require("../../assets/pc/androida.png"),
      imga1: require("../../assets/pc/android.png"),
      imga2: require("../../assets/pc/androida.png"),
      showCions: false, // 控制 cions1 显示或隐藏
      showAndroidWallet: false,
      androidDownloadQrcode: require("../../assets/pc/download.png"),
      iconSrc: require("../../assets/pc/dian.png"), // 默认图标路径
    };
  },
  created() {
    const [width, height] = [window.innerWidth, window.innerHeight];
    this.width = width;
    this.height = height;
    this.getShowMenu(this.$route.path);
    this.getPath(this.$route.path);
    this.userName = localStorage.getItem("username");
    if (this.userName) {
      this.isLogin = false;
    }
    let _path = sessionStorage.getItem("currentPath");
    if (_path) {
      this.currentPath = _path;
    }
    // this.checkUsersStatus();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("click", this.handleDocumentClick);
    this.type = this.$i18n.locale;
    // 监听（绑定）滚轮 滚动事件
    // 动态设置显示隐藏
    this.active = true;
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleDocumentClick);
  },
  computed: {
    goPage() {
      return goPAGE();
    },
    // activeIndex:function(){

    // }
  },
  methods: {
    toggleAndroidWallet() {
      this.showAndroidWallet = !this.showAndroidWallet;
    },
    handleDocumentClick(event) {
      const wrap = this.$refs.androidWalletWrap;
      if (wrap && !wrap.contains(event.target)) {
        this.showAndroidWallet = false;
      }
    },
    toggleCions() {
      this.showCions = !this.showCions; // 切换显示状态
      // 切换图片路径
      this.iconSrc = this.showCions
        ? require("../../assets/pc/dian1.png")
        : require("../../assets/pc/dian.png");
    },
    hideCions() {
      this.showCions = false; // 鼠标移出时关闭
      this.iconSrc = require("../../assets/pc/dian.png"); // 恢复为默认图片
    },
    mouseover() {
      this.img = this.img1;
    },
    mouseout() {
      this.img = this.img2;
    },
    mouseovera() {
      this.imga = this.imga1;
    },
    mouseouta() {
      this.imga = this.imga2;
    },
    jumpPage(key, keyPush) {
      // console.log("key", key);
      this.Index = key;
      this.ElSubmenuborder = keyPush[0];
      // console.log("keyPush", keyPush);
      // console.log("2222", this.$route.path);
    },
    promptDilaogBoxBtn() {
      this.flog = false;
    },
    promptDilaogBox() {
      this.flog = true;
      this.divH = this.$refs.element.offsetHeight + 1200 + "px";
      // console.log(this.diaH);
    },
    promptDilaogBox1() {
      this.flog = true;
      this.img = this.img1;
      this.divH = this.$refs.element.offsetHeight + 1200 + "px";

      // console.log(this.diaH);
    },
    logo() {
      // 点击loge清空下拉菜单的样式，和导航的样式
      this.Index = 0;
      this.ElSubmenuborder = "";
    },
    getPath(path) {
      let activeIndex = path.split("/")[2];
      this.activeIndex = activeIndex;
      //console.log(this.activeIndex, "activeIndex");
    },
    async getUsersAddress() {
      let datas = new FormData();
      datas.append("loginName", this.userName);
      const data = await GetUsersAddress(datas);
      // const data = await GetUsersAddress(this.userName);
      if (data.code == 0) {
        this.moneyAddress = data.data;
        this.dialogType = "money";
        this.dialogVisible = true;
      }
    },
    async checkUsersStatus() {
      this.userName = localStorage.getItem("username");

      let datas = new FormData();
      datas.append("loginName", this.userName);
      const data = await CheckUsersStatus(datas);
      // console.log(this.userName);
      //  console.log(data);
      this.usersStatus = data.data;
      localStorage.setItem("usersStatus", data.data);
    },
    logout() {
      this.$confirm(
        this.$t("index.switch") === "cn"
          ? "确定退出当前账号?"
          : "Make sure to exit the current account?",
        this.$t("index.switch") === "cn" ? "提示" : "prompt",
        {
          confirmButtonText:
            this.$t("index.switch") === "cn" ? "确定" : "confirm",
          cancelButtonText:
            this.$t("index.switch") === "cn" ? "取消" : "cancel",
          type: "warning",
        }
      )
        .then(async () => {
          const data = await WebLogout();
          if (data.code == "0") {
            this.$message({
              type: "success",
              message:
                this.$t("index.switch") === "cn" ? "退出成功" : "success",
            });
            localStorage.setItem("username", "");
            this.isLogin = true;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message:
              this.$t("index.switch") === "cn"
                ? "已取消退出"
                : "Cancelled exit",
          });
        });
    },
    getShowMenu(path) {
      let isGoback = true;
      for (const item of this.pathList) {
        if (path === item.path) {
          isGoback = item.isGoback;
          break;
        }
      }
      this.isGoback = isGoback;
    },
    goBack() {
      this.$router.back(-1);
    },
    login() {
      this.dialogVisible = true;
      this.dialogType = "login";
      this.$nextTick(() => {
        this.$refs.login.getCaptchaImage();
      });
    },
    check() {
      this.dialogVisible = true;
      this.dialogType = "check";
    },
    close() {
      if (this.$refs.login) {
        this.$refs.login.type = "login";
      }
      this.dialogType = "";
      this.dialogVisible = false;
      // this.checkUsersStatus();
    },
    handleClose(done) {
      this.$confirm(
        this.$t("index.switch") === "cn" ? "确认关闭？" : "Confirm shutdown?"
      )
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handlelanguage() {
      let type = "";
      if (this.type == "en") {
        type = "zh";
        this.language = "ZH";
        this.language2 = "EN";
      }
      if (this.type == "zh") {
        type = "en";
        this.language = "EN";
        this.language2 = "ZH";
      }
      sessionStorage.setItem("locale", type);
      this.type = sessionStorage.getItem("locale");
      this.$i18n.locale = sessionStorage.getItem("locale");
    },
    changelang() {
      let type = "";
      if (this.type == "en") {
        type = "zh";
        this.language = "EN";
      }
      if (this.type == "zh") {
        type = "en";
        this.language = "中文";
      }
      sessionStorage.setItem("locale", type);
      this.type = sessionStorage.getItem("locale");
      this.$i18n.locale = sessionStorage.getItem("locale");
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.headerclass = false;
      } else {
        this.headerclass = true;
      }
    },
    showUserInfo(name) {
      this.isLogin = false;
      this.userName = name;
    },
  },
};
</script>
<style lang="less" scoped>
button {
  position: absolute;
  top: 30px;
  right: 0;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.el-dropdown-menu {
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
  opacity: 1;
  border-radius: 9px;
  padding: 18px 15px 15px !important;
  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    padding: 0 !important;
    img {
      width: 20px;
      height: 20px;
      margin-right: 14px;
    }
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 21px;
    color: #61678c;
    opacity: 1;
  }
}
.language {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 20px;
  div {
    display: flex;
    align-items: center;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  span {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    border-bottom: 1px solid #e0e6e8;
    color: #000000;
    opacity: 1;
    cursor: pointer;
  }
}
.noweight {
  font-weight: normal !important;
}
.noweight.is-active {
  font-weight: normal !important;
}

.header {
  // 导航栏居中定位
  // border: 1px solid red;
  z-index: 999999;
  position: fixed;
  top: 0;
  left: 50%;
  width: 100%;
  z-index: 99999999;
  transform: translateX(-50%);
  height: 90px;
  background: #f3f5f9;
  opacity: 1;
  .el-submenu {
    margin-right: 32px;
    top: 0;
    left: 0;
  }
  .el-menu-item {
    border: 1px solid red;
  }
  .el-submenu:hover {
    border-bottom: 2px solid #0046ff;
    box-sizing: border-box;
  }
  .El-Submenu {
    border-bottom: 2px solid #0046ff !important;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 187px;
      padding-top: 30px;
      line-height: 90px;
      margin-left: 20px;
    }
  }
}
.content {
  width: 1200px;
  height: 80px;
  // width: 1140px;
  margin: 0 auto;
  line-height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .nav {
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 21px;
    -webkit-background-clip: text;
    padding-right: 20px;
    li {
      height: 100%;
      // text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 79px;
      color: rgba(0, 0, 0, 0.5);
      a {
        color: rgba(0, 0, 0, 0.5);
        opacity: 1;
      }
    }
    .el-button {
      margin-left: 22px;
      width: 79px;
      height: 39px;
      background: #000000;
      border: 1px solid #000000;
      opacity: 1;
      border-radius: 5px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      opacity: 1;
    }
  }
  .login_style {
    height: 40px;
    opacity: 1;
    border-radius: 11px;
  }
  .cions {
    display: flex;
    flex-direction: row;
    position: relative;
    a {
      background: rgba(255, 255, 255, 0.01);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      padding-left: 12px;
      img {
        width: 24px;
        height: 24px;
        margin-top: 30px;
      }
    }
    .img1 {
      width: 24px;
      height: 24px;
      margin-top: 30px;
      margin-left: 10px;
    }
    .cions1 {
      position: absolute;
      width: 164px;
      height: 64px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 0px 0px;
      top: 90px;
      img {
        margin-top: 20px;
      }
    }
    .android-wallet-wrap {
      position: relative;
      display: inline-block;
    }
    .android-wallet-trigger {
      cursor: pointer;
    }
    .android-wallet-popover {
      position: absolute;
      top: 88px;
      left: 0;
      z-index: 1000;
      width: 280px;
      padding: 14px;
      border-radius: 14px;
      background: rgba(14, 23, 48, 0.96);
      border: 1px solid rgba(255, 255, 255, 0.16);
      box-shadow: 0 18px 42px rgba(0, 0, 0, 0.28);
      .android-wallet-card {
        display: flex;
        align-items: center;
        gap: 14px;
      }
      .android-wallet-qr {
        width: 108px;
        height: 108px;
        flex-shrink: 0;
        border-radius: 10px;
        background: #fff;
        object-fit: cover;
      }
      .android-wallet-actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .android-wallet-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 116px;
        height: 40px;
        border-radius: 8px;
        background: linear-gradient(180deg, #4e8cff 0%, #1f5cff 100%);
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        text-decoration: none;
      }
      .android-wallet-tip {
        width: 118px;
        color: rgba(255, 255, 255, 0.72);
        font-size: 12px;
        line-height: 1.5;
      }
    }
  }
}

.top {
  background: #ffffff;
  // opacity: 0.8;
}
.dialog {
  z-index: 999 !important;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .details {
    width: 460px;
    background: #fff;
    position: relative;
    border-radius: 10px;
    color: #000;
    padding: 30px 30px 41px 30px;
    box-sizing: border-box;
    z-index: 10000;
    .close {
      font-size: 26px;
      cursor: pointer;
      color: #305bbc;
    }
  }
}
.none {
  display: none;
}
.block {
  display: flex;
}
// 隐藏弹框样式
.all {
  width: 100%;
  background: rgba(4, 13, 35, 0.15000000596046448);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 998 !important;
}
.promptDilaogBox {
  width: 305px;
  height: 180px;
  background: #f4f5f7;
  border-top: 10px solid #4573e7;
  box-sizing: border-box;
  padding: 47px 98px;
  text-align: center;
  cursor: pointer;
  p {
    text-align: center;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #2b2d41;
    margin: 0;
  }
  .promptDilaogBoxBtn {
    margin-top: 36px;
    width: 110px;
    height: 40px;
    background: #4573e7;
    border-radius: 5px 5px 5px 5px;
    border: none;
    font-size: 16px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    box-sizing: border-box;
    line-height: 40px;
    cursor: pointer;
  }
}
.active {
  position: absolute;
  top: 15%;
  left: 40%;
  // transform: translate(75%, 60%);
}
</style>
<style lang="less">
.Socialimg {
  //border: 1px solid red;
  margin-left: 20px;
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
// .el-submenu__title:hover{
//   color: #;
// }
.el-submenu__title {
  height: 78px !important;
  font-size: 18px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 550 !important;
  padding: 0px;
  border: none !important;
  // color: rgba(0, 0, 0, 0.5) !important;
  // color: #151B26 !important;
}
.el-menu--horizontal {
  left: 0 !important;
  width: 100%;
  height: 350px;
  background-color: #fff;
  .el-menu--popup {
    .el-menu-item-group {
      ul {
        // .DOnetwork-introductory{
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        // color: #151b26 !important;
        line-height: 16px;
        -webkit-background-clip: text;
        // }
      }
    }
  }
}
.el-menu-vertical-demo {
  background-color: rgba(0, 0, 0, 0);
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .el-menu--horizontal {
    .el-menu-item {
      height: 80px;
      line-height: 80px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // font-weight: 500;
      // color: #151b26;
      // color: #151b26 !important;
      opacity: 1;
      // background-clip: #fff;
    }
    .el-menu {
      width: 1200px;
      margin: 0 auto;
      // background-color: #000;
    }
  }
  .el-submenu__icon-arrow {
    font-size: 16px;
  }

  .el-submenu__title i {
    color: #000000;
  }
  .el-menu-item-group {
    display: inline;
    flex-direction: row;
  }
}
.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-left: 0;
}
// 导航栏底部边框不显示
.el-menu.el-menu--horizontal {
  border-bottom: none;
  left: 0 !important;
  width: 100% !important;
}

.el-submenu.is-opened .el-submenu__title {
  background-color: rgba(0, 0, 0, 0);
}
// 导航栏鼠标移入hover
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: #0046ff !important;
  background-color: rgba(0, 0, 0, 0);
  font-size: 20px;
  text-align: left;
}
.el-submenu__title .el-menu--horizontal {
  left: 0 !important;
  width: 100% !important;
  background-color: #1d3244;
}
.el-menu--horizontal > .el-submenu {
  height: 80px;
  line-height: 80px;
  .el-menu-item {
    // background-color: #01192e;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border: none;
    font-weight: 400;
    box-sizing: border-box;
  }
}
.el-menu--horizontal > .el-menu-item {
  padding: 0;
  font-size: 18px !important;
  border: none;

  a {
    display: inline-block;
    height: 100%;
    width: 100%;
  }
}

a,
a:active,
a:link,
a:visited {
  text-decoration: none;
  // color: #151b26 !important;
  font-weight: 500;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
  font-weight: 600;
  a {
    border-bottom: 3px solid #786bff;
  }
}
.el-menu--horizontal .el-menu {
  padding: 8px 0;
  // box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
  width: 1200px;
  //  border: 1px solid red;

  // background-color: #000;
  margin: 0 auto;
  // margin-top: 100px;
  box-sizing: border-box;
  .xiazaia {
    margin-top: 16px;
  }
  .xiazai {
    // border: 1px solid red;
    height: 50px;
    line-height: 50px;
  }
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    // border: none;
    box-sizing: border-box;
    // color: #151b26 !important;\

    a:hover {
      width: 280px;
      height: 44px;
      border-radius: 3px;
      border: 1x solid #edf1f2 !important;
      background: #fafafa !important;
      box-sizing: border-box;
      color: #0046ff !important;
    }
    img {
      width: 20px;
      height: 20px;
      margin-top: -4px;
      //  / border: 1px solid red;
      margin-right: 4px;
    }
  }
  .el-menu-item:hover {
    text-align: left;
    color: #323bcc;
  }
}

.el-menu--horizontal > .el-submenu:last-child {
  border: none;
  margin-right: 0px;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border: none;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 26px;
  text-align: center;
  // color: #ffffff;
  line-height: 80px;
  margin: 0 32px 0 0;
  box-sizing: border-box;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 22px;
  text-align: center;
  color: #ffffff;
  line-height: 80px;
}
.el-menu-item-group__title {
  padding-left: 20px !important;
}
.menu-item-group {
  float: left;
  text-align: left;
  span {
    display: inline-block;
    border-bottom: 1px solid #e0e6e8;
    text-align: left;
    // margin-bottom: 10px;
    padding-bottom: 30px;
  }
  .span1 {
    float: left;
    // display: inline-block;
  }
  .span2 {
    float: left;
    .DOnetwork {
      margin-left: 10px;
    }
    // display: inline-block;
  }
  .lfet {
    margin-top: 30px;
    width: 260px;
    height: 22px;
    margin-right: 20px;
    // padding-left: 20px;
    font-size: 14px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #9a9a9a;
    line-height: 16px;
    letter-spacing: 2px;
    -webkit-background-clip: text;
  }
  .right {
    margin-top: 30px;
    width: 820px;
    height: 22px;
    font-size: 14px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #9a9a9a;
    line-height: 16px;
    letter-spacing: 2px;
    -webkit-background-clip: text;
  }

  .el-menu-item {
    width: 140px;
    height: 22px;
  }
}

.el-menu--popup {
  box-shadow: none;
}
.DOnetwork-introductory {
  line-height: 16px;
  font-size: 14px;
  font-weight: 550;
  text-align: left;
  margin-left: 10px;
  // color: #151b26 !important;
  font-family: Poppins-Medium, Poppins;
  -webkit-background-clip: text;
}
.DOnetwork-introductory:nth-child(4) {
  margin-bottom: 104px;
}
.DOnetwork-introductory:hover {
  width: 280px;
  height: 44px;
  border-radius: 3px;
  // border: 1px solid #edf1f2 !important;
  background: #fafafa !important;
  box-sizing: border-box;
  color: #0046ff !important;
}
.DOnetwork-introductory2.all {
  width: 130px;
  height: 44px;
  // border-radius: 3px;
  // border: 1x solid #edf1f2 !important;
  // background: #fafafa !important;
  // box-sizing: border-box;
  // color: #0046ff !important;
}
.DOnetwork-introductory2 {
  width: 130px !important;
  height: 44px !important;
  // display: inline-block;
}
.active2 {
  width: 130px !important;
  height: 44px;
  border-radius: 3px;
  // border: 1px solid #edf1f2 !important;
  background: #fafafa !important;
  color: #0046ff !important;
}
.active1 {
  width: 280px !important;
  height: 44px;
  border-radius: 3px;
  // border: 1px solid #edf1f2 !important;
  background: #fafafa !important;
  color: #0046ff !important;
}

.GUIDESt-style1 {
  width: 260px;
  height: 22px;
}
.GUIDESt-style2 {
  width: 457px !important;
  height: 22px !important;
}
.GUIDESt-style3 {
  width: 260px !important;
  height: 22px !important;
  margin-left: 70px;
}
.DOnetwork {
  margin: 0 0 0 80px;
}
</style>
